import moment from 'moment'

export const adjustDate = date => { console.log(date); return date
    ? moment(date).toISOString().replace(".000Z","Z")
    : null
}

export const justDate = date => {
    return moment(date).format('MM-DD-YYYY')
}

// compact list-cell timestamp: "6/6 9:30a" (drops leading zeros and the
// trailing "m" on am/pm). shared by the support-ticket list and the ops
// desk list so both render dates the same way; cells keep the full ISO
// on a title tooltip for audit-level detail.
export const formatDateTimeCompact = value => {
    if (!value || typeof value !== 'string') return ''
    const m = moment(String(value))
    if (!m.isValid()) return ''
    return m.format('M/D h:mma').replace(/(a|p)m$/, '$1')
}

// year-bearing sibling of formatDateTimeCompact: "6/6/25 9:30a". for lists
// that span more than the current year (support-ticket list), where an
// ambiguous month/day would mislead.
export const formatDateTimeCompactYear = value => {
    if (!value || typeof value !== 'string') return ''
    const m = moment(String(value))
    if (!m.isValid()) return ''
    return m.format('M/D/YY h:mma').replace(/(a|p)m$/, '$1')
}

// time-only sibling of formatDateTimeCompact: "9:30a". for chrome where the
// date is already implied by context (today-only board lanes, generated-at
// stamps); keep the full value on a title tooltip when it matters.
export const formatTimeCompact = value => {
    if (!value || typeof value !== 'string') return ''
    const m = moment(String(value))
    if (!m.isValid()) return ''
    return m.format('h:mma').replace(/(a|p)m$/, '$1')
}